(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-coupon-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-coupon-code')) {
    customElements.define('bb-coupon-code', class extends HTMLElement {
      connectedCallback() {
        if (this.button) return;
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.button.hidden = false;
        this.querySelector('[data-coupon-fallback]').hidden = true;
        this.button.addEventListener('click', () => this.copyCode());
      }

      disconnectedCallback() {
        clearTimeout(this.resetTimer);
      }

      legacyCopy(code) {
        const input = document.createElement('textarea');
        input.value = code;
        input.readOnly = true;
        input.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px;';
        document.body.appendChild(input);
        try {
          input.focus({ preventScroll: true });
          input.select();
          input.setSelectionRange(0, code.length);
          return document.execCommand('copy');
        } catch (error) {
          return false;
        } finally {
          input.remove();
          this.button.focus({ preventScroll: true });
        }
      }

      async copyCode() {
        if (this.copying) return;
        this.copying = true;
        clearTimeout(this.resetTimer);
        let copied = false;
        const code = this.dataset.code;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          try {
            await navigator.clipboard.writeText(code);
            copied = true;
          } catch (error) {
            copied = this.legacyCopy(code);
          }
        } else {
          copied = this.legacyCopy(code);
        }
        this.copying = false;
        this.dataset.state = copied ? 'copied' : 'error';
        this.status.textContent = copied ? this.dataset.copied : this.dataset.copyError;
        if (!copied) {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('.bb-coupon-value'));
          selection.removeAllRanges();
          selection.addRange(range);
        }
        this.resetTimer = setTimeout(() => {
          delete this.dataset.state;
          this.status.textContent = '';
        }, copied ? 3000 : 6000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
